import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Review, getMessage, Button, ReviewItem } from '../../index';
import { ReviewActions, ReviewDialogActions, UploadActions } from '../../../actions';
import { getReviewValidations } from '../../../data';
import { hasValue } from '../../../utils/Utils';
import { REVIEW_TYPES } from '../../../constants';

const mapDispatchToProps = dispatch => ({
    getReviews: model => dispatch(ReviewActions.getReviews(model)),
    addReview: model => dispatch(ReviewActions.addReview(model)),
    setDialogOptions: model => dispatch(ReviewDialogActions.setOptions(model)),
    uploadImages: model => dispatch(UploadActions.uploadQueue(model))
});

const mapStateToProps = state => {
    const messages = state.get('localization').get('messageProperties');
    const reviewData = state.get('review').toJS();
    const { data } = state.get('asset').get('data').toJS();
    const { isLoggedIn, accountInfo = {} } = state.get('user').toJS();
    return { messages, reviewData, assetData: data, isLoggedIn, accountId: accountInfo.id };
};

const SORT_OPTIONS = [
    { label: 'messages.com.epicgames.plugin.store.filter.newest_first', value: 'CREATEDAT', dir: 'DESC' },
    { label: 'messages.com.epicgames.plugin.store.filter.oldest_first', value: 'CREATEDAT', dir: 'ASC' },
    { label: 'messages.com.epicgames.plugin.store.asset.questions.sort.helpful_desc', value: 'HELPFULNUMBER', dir: 'DESC' },
    { label: 'messages.com.epicgames.plugin.store.asset.questions.sort.helpful_asc', value: 'HELPFULNUMBER', dir: 'ASC' },
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.sort.rating_desc', value: 'RATING', dir: 'DESC' },
    { label: 'messages.com.epicgames.plugin.store.asset.reviews.sort.rating_asc', value: 'RATING', dir: 'ASC' }
];

const AssetReviews = props => {
    const type = REVIEW_TYPES.REVIEW;
    const { messages, assetData = {}, reviewData = {}, isLoggedIn, accountId,
        getReviews, addReview, uploadImages, setDialogOptions, preventScroll, showLegacyComments } = props;
    const { id, owned, seller = {}, legacyCommentCount } = assetData;
    const sellerId = seller.owner;
    const { detail, data = {} } = reviewData;
    const enableAddReview = isLoggedIn && owned && accountId !== sellerId && !hasValue(detail);
    const selectOptions = SORT_OPTIONS.map(it => ({ text: getMessage(messages, it.label), value: `${it.value}_${it.dir}` }));

    const onSearch = params => {
        if (id) {
            getReviews({ ...params, type, offerId: id });
        }
    };

    const showReviewDialog = () => {
        const options = {
            headerText: `messages.com.epicgames.plugin.store.asset.${type}.btn.add`,
            saveText: `messages.com.epicgames.plugin.store.asset.${type}.dialog.submit.add`,
            summaryPlaceholder: `messages.com.epicgames.plugin.store.asset.${type}.summary`,
            descPlaceholder: `messages.com.epicgames.plugin.store.asset.${type}.desc`,
            validations: getReviewValidations(messages, true, 4000, true),
            isVisible: true,
            isSummaryEnable: true,
            isRatingEnable: true,
            isDescEnable: true,
            isImageEnable: true,
            contentMaxLength: 4000,
            defaultValue: detail,
            onSave: value => {
                const nextData = { ...value, offerId: id, targetOwner: sellerId, type };
                if (nextData.images) {
                    uploadImages({
                        type,
                        files: nextData.images,
                        onSuccess: images => {
                            addReview({ ...nextData, images });
                        }
                    });
                } else {
                    addReview(nextData);
                }
            }
        };
        setDialogOptions(options);
    };

    const renderPostBtn = () => {
        if (!enableAddReview) return null;
        return (
            <Button className="asset-reviews__btn--new" onClick={showReviewDialog}>
                {getMessage(messages, `messages.com.epicgames.plugin.store.asset.${type}.btn.add`)}
            </Button>
        );
    };

    const renderList = () => {
        const { elements = [] } = data;
        return elements.map((it, idx) => (
            <ReviewItem
                type={type}
                key={`review-item-${idx}`}
                data={{ isReplyEnabled: true, ...it }}
            />
        ));
    };

    const preventScrollVal = !hasValue(assetData) || preventScroll;
    return (
        <Review
            onSearch={onSearch}
            preventScroll={preventScrollVal}
            renderEmptyBtn={renderPostBtn}
            isLegacyCommentsEnabled={legacyCommentCount > 0}
            showLegacyComments={showLegacyComments}
            type={type}
            messages={messages}
            reviewData={reviewData}
            selectOptions={selectOptions}>
            {renderList()}
        </Review>
    );
};

AssetReviews.propTypes = {
    messages: PropTypes.object,
    assetData: PropTypes.object,
    reviewData: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    accountId: PropTypes.string,
    getReviews: PropTypes.func,
    addReview: PropTypes.func,
    uploadImages: PropTypes.func,
    setDialogOptions: PropTypes.func,
    preventScroll: PropTypes.bool,
    showLegacyComments: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetReviews);
